module.exports = __webpack_public_path__ + "static/media/564.5b933fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/564.png
// module id = 774
// module chunks = 0